import React from 'react';
import Modal from '../../common/Modal';
import { useLanguage } from '../../../context/LanguageContext';

const EditingProtectionModal = ({
    isOpen,
    onCancel,
    onDiscard,
    onSave,
    editingOrderKey,
    pendingOrders,
}) => {
    const { t } = useLanguage();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            title={t('order_editing_in_progress')}
            footer={(
                <>
                    <button
                        type="button"
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                        onClick={onDiscard}
                    >
                        Discard Changes
                    </button>
                    <button
                        type="button"
                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-primary-600 border border-transparent rounded-md shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                        onClick={onSave}
                    >
                        Save & Continue
                    </button>
                </>
            )}
        >
            <div className="space-y-4">
                {editingOrderKey && pendingOrders[editingOrderKey] && (
                    <>
                        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
                            <p className="text-sm text-yellow-800">
                                <strong>{t('warning')}</strong> {t('currently_editing_order_for')}{' '}
                                <strong>{pendingOrders[editingOrderKey].diningOption} {pendingOrders[editingOrderKey].tableNumber}</strong>.
                            </p>
                        </div>

                        <p className="text-sm text-gray-700">
                            {t('unsaved_changes_what_to_do')}
                        </p>

                        <div className="text-xs text-gray-500">
                            <strong>{t('current_editing_order_contains')}</strong>
                            <ul className="mt-1 space-y-1">
                                {pendingOrders[editingOrderKey].products?.slice(0, 3).map((product, idx) => (
                                    <li key={idx}>• {product.quantity}x {product.name}</li>
                                ))}
                                {pendingOrders[editingOrderKey].products?.length > 3 && (
                                    <li>• + {pendingOrders[editingOrderKey].products.length - 3} more items...</li>
                                )}
                            </ul>
                        </div>

                        <div className="space-y-2 text-sm">
                            <div><strong>{t('save_continue_description')}</strong> Save current changes and proceed with your action</div>
                            <div><strong>{t('discard_changes_description')}</strong> Lose current changes and proceed with your action</div>
                            <div><strong>{t('cancel_description')}</strong> Continue editing the current order</div>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default EditingProtectionModal;
